import { render } from "./CguComponent.vue?vue&type=template&id=484c00f9"
import script from "./CguComponent.vue?vue&type=script&lang=js"
export * from "./CguComponent.vue?vue&type=script&lang=js"

import "./CguComponent.vue?vue&type=style&index=0&id=484c00f9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__